var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "l-footer u-row cl-white" }, [
      _c("p", { staticClass: "t9 u-flex" }, [
        _vm._v("Copyright © Open Room, Inc. All Rights Reserved.")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "t10",
          attrs: { target: "_blank", href: "https://openrm.co.jp/company.html" }
        },
        [_vm._v("運営会社")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }